<template>
  <v-container height="100">
    <h3>{{selectedItem.name}}</h3>
    <div>
      <button @click="addNewTodo">Add</button>

      <p
        v-for="(todo, index) in selectedItem.todos"
        v-bind:key="index"
        v-on:remove="todos.splice(index, 1)"
      >
        {{ todo.title }}
      </p>
    </div>
  </v-container>
</template>

<script>
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      newTodoText: "",
      selectedItem: {
        name: "dkfjsdfsd",
        todos: [
          {
            id: 1,
            title: "Do the dishes",
          },
          {
            id: 2,
            title: "Take out the trash",
          },
          {
            id: 3,
            title: "Mow the lawn",
          },
        ],
      },
      nextTodoId: 4,
    };
  },
  //   props: {
  //     itemId: {
  //       required: true,
  //     },
  //   },

  methods: {
    addNewTodo: function () {
      this.todos.push({
        title: "dfsdf",
      });
      this.newTodoText = "";
    },
  },
};
</script>
